import mitt from "mitt";
import type { FC, PropsWithChildren } from "react";
import { createContext } from "react";

import { Modals } from "~/widgets/auth-modals/modals";

export type AuthModalsContext = {
  open: (name: AuthModalName) => void;
  close: () => void;
};

// eslint-disable-next-line react-refresh/only-export-components
export const authModalsProvider = createContext<AuthModalsContext | null>(null);

export type Events = {
  open: AuthModalName;
  close: null;
};

export type AuthModalName = "login" | "register" | "restore" | "successRestore";

const emitter = mitt<Events>();

export const AuthModalsProvider: FC<PropsWithChildren> = ({ children }) => {
  const close = (): void => {
    emitter.emit("close", null);
  };

  const open = (name: AuthModalName): void => {
    emitter.emit("open", name);
  };
  return (
    <authModalsProvider.Provider
      value={{
        open,
        close,
      }}
    >
      <>
        {children}
        <Modals emitter={emitter} />
      </>
    </authModalsProvider.Provider>
  );
};
